import { GaTracking, MfSegmentTracking } from '@westwing/appshell_types';
import useAppShell from '.';

export const useGaTracking = (): GaTracking => {
    const { trackingHelpers } = useAppShell();

    return { ...trackingHelpers.ga };
};

export const useSegmentTracking = (): MfSegmentTracking => {
    const { trackingHelpers } = useAppShell();

    return { ...trackingHelpers.segment };
};
